import React, { useCallback, useEffect } from 'react';
import './ViewCommissions.scss';
import { DataGrid, Button, LoadPanel, Popup, Form } from 'devextreme-react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import GlobalParams from '../../helpers/GlobalParams.js';
import { Column } from 'devextreme-react/cjs/data-grid.js';
import axios from 'axios';
import notify from 'devextreme/ui/notify';

const ViewCommissions = () => {

  const [commissionsData, setCommissionsData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);


  const fetchCommissions = async () => {
    try {
      //use axios to fetch data get
      const response = await axios.get(
        GlobalParams.ApiUrlPrefix + "broker-commissions?broker_id=" + GlobalParams.IntermediaryId,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );
      setIsLoading(false);
      setCommissionsData(response.data.data);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  }

  useEffect(() => {
    setIsLoading(true);
    fetchCommissions();
  }, []);


  return (
    <div>
      <LoadPanel visible={isLoading} />

      {/*create a pop up - display the amount and phone number to send the prompt to*/}
      <br/>
      <div style={{ color: '#2E86C1', fontWeight: 'bold' }}>Commissions</div>
      {
        <DataGrid
          dataSource={commissionsData}
          wordWrapEnabled={true}
          searchPanel={
            {
              visible: false,
              width: 250
            }
          }
        >
          <Column dataField="id" visible={false}></Column>
          <Column dataField="CommissionReference" visible={false}></Column>
          <Column dataField="requisition_no" visible={false}></Column>
          <Column dataField="DateTo" dataType='date'></Column>
          <Column dataField="TotalGrossCommission" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.TotalGrossCommission).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }}> </Column>
          <Column dataField="TotalWTax" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.TotalWTax).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }}> </Column>
          <Column dataField="TotalVAT" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.TotalVAT).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }}> </Column>
          <Column dataField="TotalNetCommission" cellRender={(cellInfo) => {
            const formattedAmount = parseFloat(cellInfo.data.TotalNetCommission).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            return (
              <span>{formattedAmount}</span>
            );
          }}> </Column>
        </DataGrid>
      }
    </div>
  );
}
export default ViewCommissions;